import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RegistrationsListComponent } from './registrations/registrations-list/registrations-list.component';
import { RegistrationCreateComponent } from './registrations/registration-create/registration-create.component';
import { RoleGuardService } from '../shared/services/role-guard.service';
import { CourseCreateComponent } from './course/course-create/course-create.component';
import { CourseDetailsComponent } from './course/course-details/course-details.component';
import { CoursesListComponent } from './course/courses-list/courses-list.component';
import { PrizeListComponent } from './prize/prize-list/prize-list.component';
import { PrizeCreateComponent } from './prize/prize-create/prize-create.component';
import { PrizeDetailsComponent } from './prize/prize-details/prize-details.component';
import { OutingsListComponent } from './outings/outings-list/outings-list.component';
import { OutingCreateComponent } from './outings/outing-create/outing-create.component';
import { OutingDetailsComponent } from './outings/outing-details/outing-details.component';
import { OutingPermissionCreateComponent } from './outings/outing-permission-create/outing-permission-create.component';
import { OutingIterationListComponent } from './outings/outing-iteration-list/outing-iteration-list.component';
import { OutingIterationCreateComponent } from './outings/outing-iteration-create/outing-iteration-create.component';
import { OutingIterationEditComponent } from './outings/outing-iteration-edit/outing-iteration-edit.component';
import { OutingIterationDetailsComponent } from './outings/outing-iteration-details/outing-iteration-details.component';
import { SponsorCreateComponent } from './sponsor/sponsor-create/sponsor-create.component';
import { SponsorDetailsComponent } from './sponsor/sponsor-details/sponsor-details.component';
import { SponsorListComponent } from './sponsor/sponsor-list/sponsor-list.component';
import { SponsorEditComponent } from './sponsor/sponsor-edit/sponsor-edit.component';
import { PrizeEditComponent } from './prize/prize-edit/prize-edit.component';
import { RegistrationsTeamsComponent } from './registrations/registrations-teams/registrations-teams.component';

const routes: Routes = [
    {
      path: 'registrations',
      component: RegistrationsListComponent,
      canActivate: [RoleGuardService]
    },
    {
      path: 'registration/create',
      component: RegistrationCreateComponent,
      canActivate: [RoleGuardService]
    },
    {
      path: 'registrations/teams',
      component: RegistrationsTeamsComponent,
      canActivate: [RoleGuardService]
    },
    {
      path: 'outings',
      component: OutingsListComponent,
      canActivate: [RoleGuardService]
    },
    {
      path: 'outing/create',
      component: OutingCreateComponent,
      canActivate: [RoleGuardService]
    },
    {
      path: 'outing/details/:id',
      component: OutingDetailsComponent,
      canActivate: [RoleGuardService]
    },
    {
      path: 'outing/permissions/create',
      component: OutingPermissionCreateComponent,
      canActivate: [RoleGuardService]
    },
    {
      path: 'outing/iterations',
      component: OutingIterationListComponent,
      canActivate: [RoleGuardService]
    },
    {
      path: 'outing/iteration/create/:id',
      component: OutingIterationCreateComponent,
      canActivate: [RoleGuardService]
    },
    {
      path: 'outing/iteration/edit/:id',
      component: OutingIterationEditComponent,
      canActivate: [RoleGuardService]
    },
    {
      path: 'outing/iteration/details/:id',
      component: OutingIterationDetailsComponent,
      canActivate: [RoleGuardService]
    },
    {
      path: 'courses',
      component: CoursesListComponent,
      canActivate: [RoleGuardService]
    },
    {
      path: 'course/create',
      component: CourseCreateComponent,
      canActivate: [RoleGuardService]
    },
    {
      path: 'course/details/:id',
      component: CourseDetailsComponent,
      canActivate: [RoleGuardService]
    },
    {
      path: 'prizes',
      component: PrizeListComponent,
      canActivate: [RoleGuardService]
    },
    {
      path: 'prize/create/:searchKey',
      component: PrizeCreateComponent,
      canActivate: [RoleGuardService]
    },
    {
      path: 'prize/details/:id',
      component: PrizeDetailsComponent,
      canActivate: [RoleGuardService]
    },
    {
      path: 'prize/edit/:id',
      component: PrizeEditComponent,
      canActivate: [RoleGuardService]
    },
    {
      path: 'sponsors',
      component: SponsorListComponent,
      canActivate: [RoleGuardService]
    },
    {
      path: 'sponsor/create/:searchKey',
      component: SponsorCreateComponent,
      canActivate: [RoleGuardService]
    },
    {
      path: 'sponsor/details/:id',
      component: SponsorDetailsComponent,
      canActivate: [RoleGuardService]
    },
    {
      path: 'sponsor/edit/:id',
      component: SponsorEditComponent,
      canActivate: [RoleGuardService]
    }
  ];

@NgModule({
    imports: [
      RouterModule.forChild(routes)
    ],
    exports: [RouterModule]
  })
  export class AdministrationRoutingModule { }
